import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  quota: {},
  quotaLoading: false,
  timeQuota: {},
  timeQuotaLoading: false,
};

const slice = createSlice({
  name: 'quotaSlice',
  initialState,
  reducers: {
    quotaSlice: (state, { payload }) => {
      state.quota = payload;
    },
    quotaLoadingSlice: (state, { payload }) => {
      state.quotaLoading = payload;
    },
    timeQuotaSlice: (state, { payload }) => {
      state.timeQuota = payload;
    },
    timeQuotaLoadingSlice: (state, { payload }) => {
      state.timeQuotaLoading = payload;
    },
  },
});

const { actions, reducer } = slice;

export const {
  quotaSlice,
  quotaLoadingSlice,
  timeQuotaSlice,
  timeQuotaLoadingSlice,
} = actions;

export default reducer;
